import products from './data/data';

// eslint-disable-next-line import/prefer-default-export
export const Api = {
  getProducts() {
    return products;
  },
};
